import Modal from 'services/modal';
import BaseService from 'services/base';
import Http from 'services/http2';

const ReceiveService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    //二次确认操作
    deliveryConfirm(
      postbody,
      dialogMsg,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(dialogMsg, ok, dispatch);
    },

    // 检验是否开启送货地址
    async checkOpenReceAddress(companyCode: string) {
      let res: boolean = false;
      let postbody = {
        companyCode,
        apiPath: '/archives/sysCtrParam/checkOpenReceAddress'
      };
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          res = response.data;
        }
      });
      return res;
    },

    //退回操作
    deliveryRuturn(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          backReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认退回？', ok, '退回', 'showReject', '', dispatch);
    },
    // 拒绝申请退回
    rejectApply(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('拒绝原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          backReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject(
        '确认拒绝？',
        ok,
        '拒绝原因',
        'showReject',
        '',
        dispatch
      );
    },

    //撤回操作
    deliveryRecall(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('撤回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          backReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认撤回？', ok, '撤回', 'showReject', '', dispatch);
    },
    //采购验收确认
    recAccConfirm(
      postbody,
      dialogMsg,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(dialogMsg, ok, dispatch);
    },
    //延迟送货确认
    confirmDdaOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/vDelayApply/confirm',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '您确认同意供应商延迟送货吗？确认后，原订单答交数据将被延迟送货申请数据覆盖。',
        ok,
        dispatch
      );
    },
    // 送货新建检验单
    async createIqcOrder(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = async () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        let rs;
        await BaseService.save(config, cb, dispatch).then(response => {
          rs = response;
        });
        return rs;
      };
      Modal.showConfirm('确认新建检验单？', ok, dispatch);
    },
    //退回操作
    orderAnswer(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          rejectReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject(
        '您确定退回答交数据吗？',
        ok,
        '退回',
        'showReject',
        '',
        dispatch
      );
    },
    //收货单确认
    receiveConfirm(
      postbody,
      dialogMsg,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(dialogMsg, ok, dispatch);
    },
    // 收货单同步ERP
    async syncReceiveNote(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = async () => {
        let config = {
          ...postbody,
          apiPath: '/receiveOrder/reSyncRo',
          successMsg: '操作成功'
        };
        let rs;
        await BaseService.save(config, cb, dispatch).then(response => {
          rs = response;
        });
        return rs;
      };
      Modal.showConfirm('确认重新同步收货单？', ok, dispatch);
    },
    // 入库单同步ERP
    async syncStorageNote(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = async () => {
        let config = {
          ...postbody,
          apiPath: '/storageOrder/reSyncSto',
          successMsg: '操作成功'
        };
        let rs;
        await BaseService.save(config, cb, dispatch).then(response => {
          rs = response;
        });
        return rs;
      };
      Modal.showConfirm('确认重新同步入库单？', ok, dispatch);
    },
    // 入库单撤回
    recallStorageNote(
      postbody: any,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('撤回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          apiPath: '/storageOrder/recall',
          recallReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认撤回？', ok, '撤回', 'showReject', '', dispatch);
    },
    //撤回收货单
    recallReceiveNote(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = async (reason?) => {
        if (!reason) {
          Modal.showError('撤回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          recallReason: reason,
          apiPath: '/receiveOrder/recall',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认撤回？', ok, '撤回', 'showReject', '', dispatch);
    }
  },
  BaseService
);

export default ReceiveService;
